<template>
  <div class="o-category-header">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <base-image
            v-if="content.image && content.image[0].Url"
            :url="content.image[0].Url"
            :width="imageWidth"
            :height="imageHeight"
            :alt-text="content.imageAltText"
            :lazy-load="false"
            class="o-category-header__picture"
            image-class="o-category-header__image"
          />
          <div v-else class="o-category-header__picture -clear" />
          <div class="o-category-header__content">
            <h1
              class="o-category-header__headline"
            >
              {{ content.headline }}
              <span v-if="currentPage > 1"> - {{ $t('Page', 'Side') }} {{ currentPage }}</span>
            </h1>
            
            <div
              v-if="$isNotNullOrUndefined(content.rteText)"
              class="o-category-header__text d-none d-lg-block"
              v-html="content.rteText"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <breadcrumb class="-content" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import contentMixin from '@/mixins/contentMixin';
import Breadcrumb from '@/components/molecules/Breadcrumb';
import BaseImage from '@/components/atoms/BaseImage';

export default {
  name: 'CategoryHeader',
  components: {
    BaseImage,
    Breadcrumb
  },
  props: {
    currentPage: {
      type: Number,
      default: 1
    }
  },
  mixins: [contentMixin],
  data () {
    return {
      imageWidth: 1376,
      imageHeight: 250,
      test: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s'
    }
  },
  computed: {
    placeholder () {
      return this.$store.getters['site/getPlaceholder'];
    },
  }
};
</script>
